import du from '../utils/dom-utilities';

/**
 * Sync value from header input search to the hidden input on form
 *
 * @function
 * @param {HTMLElement} $visible
 * @param {HTMLElement} $hidden
 */
export function _syncInput($visible, $hidden){
    if (!$visible || !$hidden) {
        throw new Error('Missing $visible and/or $hidden node');
    }
    $visible.value = $hidden.value;

    $visible.addEventListener('keydown', event => {
        $hidden.value = event.target.value;
        var keyCode = event.which || event.keyCode;
        if (keyCode === 13) {
            du.getClosest($hidden, 'form').submit();
        }
    });

};

/**
 * Set search input on the header
 *
 * @function
 * @param {Object} options - options
 * @param {string} options.dropAreaSelector - options
 * @param {string} options.headerSelector - options
 * @param {string} options.headerModifier - options
 * @param {string} html - Html to insert in place of the hero title
 */
export function _setVisibleSearch(options, html) {
    let dropItem = document.querySelector(options.dropAreaSelector);
    dropItem.insertAdjacentHTML('afterend', html);
    dropItem.parentNode.removeChild(dropItem);
    document.querySelector(options.headerSelector).classList.add(options.headerModifier);
}

/**
 * Set a search input on the header and keep it sync with the original form
 *
 * @function
 * @param {Object} customOptions - To overwide options
 */
export default function syncSearchPage (customOptions = {}) {
    let options = {
        inputSourceId: 'search-portlet-input',
        inputVisibleId: 'search-portlet-input-visible',
        dropAreaSelector: '[data-hero-page-title]',
        headerSelector: '.header',
        headerModifier: 'header--search'
    };
    options = du.extend(options, customOptions);
    let heroForm = `<div class="form hero__form">
                        <input title="${QUEBECOR_TRANSLATE.search}" type="text"
                            class="form__item form__item--search" id="${options.inputVisibleId}"/>
                    </div>`;
    let inputSource = document.getElementById(options.inputSourceId);

    if (inputSource) {
        _setVisibleSearch(options, heroForm);
        _syncInput(document.getElementById(options.inputVisibleId), inputSource);
    }

}



// WEBPACK FOOTER //
// ./src/main/js/components/syncSearchPage.js